import React, { FC } from 'react';
import { Dialog, Button, makeStyles, DialogTitle, DialogActions, Typography, DialogContent, DialogContentText } from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import WarningIcon from '@material-ui/icons/Warning';
export interface AlertProps {
  open: boolean;
  title: string;
  subtitle?: string;
  onConfirm?: () => void;
  onCancel?: () => void;
  type?: 'success' | 'error' | 'warning';
}

const Alert: FC<AlertProps> = (props) => {
  const classes = useStyles();
  const { open, title, onConfirm, onCancel, type } = props;

  const renderIcon = () => {
    switch (type) {
      case 'success':
        return <CheckCircleIcon className={classes.textSuccess} />;
      case 'error':
        return <ErrorIcon className={classes.textError} />;
      case 'warning':
        return <WarningIcon className={classes.textInfo} />;
      default:
        return <InfoIcon className={classes.textInfo} />;
    }
  };

  return (
    <Dialog open={open}>
      <DialogTitle disableTypography>
        <div style={{ textAlign: 'center' }}>{renderIcon()}</div>
        <Typography variant="h4" color="primary" align="center">
          {title}
        </Typography>
      </DialogTitle>
      {props.subtitle && (
        <DialogContent>
          <DialogContentText id="alert-dialog-description">{props.subtitle}</DialogContentText>
        </DialogContent>
      )}
      <DialogActions>
        {!!onCancel && (
          <Button color="primary" variant="outlined" className={classes.actions} onClick={onCancel}>
            Cancelar
          </Button>
        )}
        <Button color="primary" variant="contained" className={classes.actions} onClick={onConfirm}>
          Aceptar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const useStyles = makeStyles((theme) => ({
  dialogContainer: { padding: 30 },
  actions: { flex: 1 },
  textSuccess: { fontSize: 50, color: theme.palette.success.main },
  textError: { fontSize: 50, color: theme.palette.error.main },
  textInfo: { fontSize: 50, color: theme.palette.primary.main }
}));

export default Alert;
